import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import CustomList14 from "./CustomList14";
import { FiChevronRight, FiClock } from "react-icons/fi";
import { IoReceiptOutline } from "react-icons/io5";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { RiFileList3Line } from "react-icons/ri";
import { LiaClipboardListSolid } from "react-icons/lia";
import { FaCheckCircle, FaListAlt, FaLock, FaTrashAlt } from "react-icons/fa";
import { BiLock } from "react-icons/bi";

const DayEndList = React.memo(({ close, path }) => {
  const [focused, setFocused] = useState([]);
  const navigate = useNavigate();
  const { user_type, emp_data } = useSelector((state) => state.other);
  const permission_handle = (permissions = []) => {
    return (
      user_type === "admin" || permissions.some((perm) => emp_data?.[perm])
    );
  };

  const dayEndMenu = [
    {
      title: "Transaction Verification",
      icon: <FaCheckCircle color="#6e82a5" size={15} />,
      route: "/DayReport/TransactionVerification",
      activePath: "/DayReport/TransactionVerification",
      permission: "DAY_END_PERMISSION", // remaining
    },
    // {
    //   title: "Delete Records Logs",
    //   icon: <FaTrashAlt color="#6e82a5" size={13} />,
    //   route: "/DayReport/DeleteRecordsLogs",
    //   activePath: "/DayReport/DeleteRecordsLogs",
    //   permission: "DAY_END_PERMISSION", // remaining
    // },
    // {
    //   title: "Vehicle Tracking",
    //   icon: <FaListAlt color="#6e82a5" size={13} />,
    //   route: "/DayReport/VehicleTracking",
    //   activePath: "/DayReport/VehicleTracking",
    //   permission: "DAY_END_PERMISSION", // remaining
    // },
    {
      title: "Day Summary",
      icon: <FaListAlt color="#6e82a5" size={13} />,
      route: "/DayReport/DaySummary",
      activePath: "/DayReport/DaySummary",
      permission: "DAY_END_PERMISSION", // remaining
    },
    {
      title: "Day End",
      icon: <FaLock color="#6e82a5" size={13} />,
      route: "/DayReport/end",
      activePath: "/DayReport/end",
      permission: "DAY_END_PERMISSION", // remaining
    },
  ];
  return (
    <>
      {permission_handle(dayEndMenu?.map((v) => v?.permission)) && (
        <div
          className="list-main mt10"
          onClick={() =>
            setFocused((pre) =>
              pre.find((v) => v == "DayEnd")
                ? pre.filter((v) => v != "DayEnd")
                : ["DayEnd"],
            )
          }
        >
          <div className="list-icon">
            <BiLock color="#6e82a5" size={19} />

            {/* <LiaClipboardListSolid color="#6e82a5" size={16} /> */}
          </div>
          <div className="list-title fs15">Day Report</div>
          <div className="list-arrow">
            <FiChevronRight
              size={18}
              className={
                focused.includes("DayEnd") ? "rotate-down" : "rotate-right"
              }
            />
          </div>
        </div>
      )}
      <AnimatePresence initial={false}>
        {focused.includes("DayEnd") && (
          <motion.section
            style={{ marginLeft: 15, overflow: "hidden" }}
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 1, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {dayEndMenu.map((v, i) => (
              <>
                {permission_handle([v?.permission]) && (
                  <CustomList14
                    key={i}
                    title={v?.title}
                    style={{
                      backgroundColor: path == v?.route ? "white" : "",
                    }}
                    type={v?.permission}
                    onClick={() => {
                      navigate(v?.route);
                      close();
                    }}
                    icon={v?.icon}
                  />
                )}
              </>
            ))}
          </motion.section>
        )}
      </AnimatePresence>
    </>
  );
});

export default DayEndList;
